import { NavigateLink } from "@/components/navigate/NavigateLinks";
import { NavigateFunction } from "react-router-dom";

export const startPageBreadcrumbs = (navigate: NavigateFunction): NavigateLink[] => [
  { label: 'Inicio', onClick: () => navigate('/') },
];

export const fleetPageBreadcrumbs = (navigate: NavigateFunction): NavigateLink[] => [
  { label: 'Inicio', onClick: () => navigate('/') },
  { label: 'Flota', onClick: () => navigate('/fleet') },
];